export default {
	init() {
		// JavaScript to be fired on the home page

		// Cache element
		var $root = $('html, body');

		// Scroll animato ancora da altra pagina
		let target = $(window.location.hash);
		if (target.length > 0) {
			setTimeout(function() {
				if ($('nav.desktop').is(':visible')) {
					animateDesktopAnchor(target);
				} else {
					animateMobileAnchor(target);
				}
			}, 300);
		}

		// Scroll animato ancora DESKTOP
		$('nav.desktop a[href*="#"]').click(function(event) {
			event.preventDefault();
			let target = $(this.hash);
			animateDesktopAnchor(target);
		});

		// Scroll animato ancora MOBILE
		$('.nav-mobile a[href*="#"]').click(function(event) {
			event.preventDefault();
			let target = $(this.hash);
			animateMobileAnchor(target);
		});

		function animateDesktopAnchor(target) {
			var offsetAdjust = 180;
			if (isScrolled()) {
				offsetAdjust = 100;
			}
			$root.animate({
				scrollTop: target.offset().top - offsetAdjust,
			}, 800);
		}

		function animateMobileAnchor(target) {
			$root.animate({
				scrollTop: target.offset().top - 70,
			}, 800);
		}

		function isScrolled() {
			if ($(window).scrollTop() >= 130) {
				return true;
			}
			return false;
		}
	},

	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js